export default "__VITE_ASSET__CllqnzQU__"